// extracted by mini-css-extract-plugin
module.exports =  {"address":"_02712f2b3b--address--LYVYi","address-fulladdress":"_02712f2b3b--address-fulladdress--LqKl9","address-underground":"_02712f2b3b--address-underground--xgoac"};